import React, { useState } from 'react';
import '../css/Faq.css'
import { IoIosArrowDown } from "react-icons/io";
import Button from './Button.js';
import VideoModal from './VideoModal.js';

const CourseContent = ({ data, link }) => {
    const [selectedModule, setSelectedModule] = useState(null);
    const toggleModule = (index) => {
        setSelectedModule(selectedModule === index ? null : index);
    };

    return (
        <div className="content-container">
            <h2
                className='large'>
                Conteúdo do Curso
            </h2>
            <VideoModal
                text={"Assista uma aula..."}
                videoUrl={"https://www.youtube.com/embed/qG-hfqzPDrE?si=ZZS3bOj0C7Hl8vJo"}
            />
            {data.map((item, index) => (
                <div
                    key={index}
                    className="content-item subtitle">
                    <div
                        className={`module ${selectedModule === index ? 'active' : ''}`}
                        onClick={() => toggleModule(index)}>
                        <div>{item.module}</div> <div><IoIosArrowDown /></div>
                    </div>
                    <div className={`topic-container ${selectedModule === index ? 'visible' : ''}`}>
                        <ul className="topic">
                            {item.topics.map((topic, topicIndex) => (

                                <li key={topicIndex} >
                                    {topic}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            ))}
            <Button href={link} />
        </div>

    );
};

export default CourseContent;
